import React from 'react'
import {UserContextProvider} from '../../context/User'
import SessionCookies from '../../utils/sessionCookies'
import {UsersContextProvider} from '../../context/Users'
import {ReservationConfigurationContextProvider} from '../../context/ReservationConfiguration'
import {DialogContextProvider} from '../../context/Dialog'
import {ToastMessageContextProvider} from '../../context/ToastMessage/ToastMessage'

function ReservationConfigurationInitialize({children}) {
  return (
    <SessionCookies>
      <ToastMessageContextProvider>
        <DialogContextProvider>
          <UserContextProvider>
            <ReservationConfigurationContextProvider>
              <UsersContextProvider>{children}</UsersContextProvider>
            </ReservationConfigurationContextProvider>
          </UserContextProvider>
        </DialogContextProvider>
      </ToastMessageContextProvider>
    </SessionCookies>
  )
}

export default ReservationConfigurationInitialize
